import { site } from "@/config/site";

// One slow editorial marquee of the business's approved trust claims.
export function Marquee({ dark = false }) {
  const items = [...site.trustClaims, ...site.trustClaims];
  return (
    <div
      className={`overflow-hidden marquee-mask border-y ${
        dark
          ? "border-white/10 bg-navy-950 text-white/80"
          : "border-warm-200 bg-warm-100 text-navy-900"
      }`}
      aria-hidden="true"
      data-testid="trust-marquee"
    >
      <div className="animate-marquee flex w-max items-center py-4">
        {items.map((c, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-lg sm:text-xl tracking-wide px-8 whitespace-nowrap">
              {c}
            </span>
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                dark ? "bg-white/30" : "bg-navy-900/30"
              }`}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
